import React from 'react';
import styles from "./styles.module.scss";

interface PageLayoutProps {
  heading?: string;
  paragraph?: string;
  headerActions?: React.ReactNode;
  footerActions?: React.ReactNode;
  children?: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ heading, paragraph, headerActions, footerActions, children }) => {
  return (
    <div className={styles.pageLayout}>
      <header className={styles.header}>
        <section className={styles.section}>
          <p className={styles.heading}>{heading}</p>
          <div className={styles.actions}>
            {headerActions}
          </div>
        </section>
        {paragraph && <p className={styles.paragraph}>{paragraph}</p>}
      </header>
      
      <main className={styles.mainContent}>
        {children}
      </main>
      
      {/* <footer className={styles.footer}>
        <section className={styles.footerSection}>
          <div className={styles.actions}>
            {footerActions}
          </div>
        </section>
      </footer> */}
    </div>
  );
};

export default PageLayout;
